import { React } from "react";
import { Link } from 'react-router-dom'

const Hero = () => {
    return (
        <>
            <div id="home" className="hero-section position-relative overflow-hidden p-5 p-md-5 text-center">
                <div className="col-md-8 d-flex flex-column justify-content-center align-items-center p-lg-5 mx-auto my-5 text-primary fw-bold">
                    <h1 className="display-4 mt-5 fw-bolder mb-4 hero-title"
                        data-aos="fade-down"
                        data-aos-duration="800">Welcome to Bluecoder</h1>
                    <p className="lead fw-normal mb-5 hero-desc" data-aos="fade-up"
                        data-aos-delay="200"
                        data-aos-duration="1500">We Help To Design And Develop Highly Responsive Websites For Your Business That Integrates Seamlessly with Existing Business As Well As To Grow New Startup Business.</p>
                    <Link to="/services" className="hero-btn btn btn-outline-danger border border-danger py-2 px-4 rounded-pill border-2 get-started"
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        data-aos-duration="1000">Exclusive Services</Link>
                </div>

                <div className="product-device shadow-sm d-none d-md-block"></div>
                <div className="product-device product-device-2 shadow-sm d-none d-md-block"></div>
            </div>
        </>
    )
}

export default Hero